import axios from 'axios';

export function isUnauthorizedError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) {
    return false;
  }
  return (
    error.response?.status === 401 ||
    error.message === 'Request failed with status code 401'
  );
}
